var React = require('react');

function RightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.859.565l-.495.87C19.26 12.18 25.25 30.31 18.338 55.95l-.213.78-1.816 5.775-1.5-7.113-.978.206 1.891 8.982.184.87.648-.608 6.693-6.281-.684-.73-5.301 4.975 1.822-5.793C26.448 30.531 20.374 11.665.859.565z","fill":"#97979d","fillRule":"nonzero"}));
}

RightInline.defaultProps = {"width":"24","height":"66"};

module.exports = RightInline;

RightInline.default = RightInline;
